import { render, staticRenderFns } from "./RejectedCoursesSelection.vue?vue&type=template&id=35670b82"
import script from "./RejectedCoursesSelection.vue?vue&type=script&lang=js"
export * from "./RejectedCoursesSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports